import React from 'react';
import { ShoppingBag } from 'lucide-react';
interface EcommerceBrandsProps {
  language: 'en' | 'es';
}
export function EcommerceBrands({
  language
}: EcommerceBrandsProps) {
  const content = {
    en: {
      title: 'Funding for E-Commerce Entrepreneurs',
      subtitle: 'We help Shopify, Amazon, Etsy, Walmart and DTC sellers scale inventory, ads, and product launches — without the delays of traditional banks. No credit pull • Bank-level security • Funding in 24h'
    },
    es: {
      title: 'Financiamiento para Emprendedores de E-Commerce',
      subtitle: 'Ayudamos a vendedores de Shopify, Amazon, Etsy, Walmart y DTC a escalar inventario, anuncios y lanzamientos de productos — sin las demoras de los bancos tradicionales. Sin revisión de crédito • Seguridad bancaria • Fondos en 24h'
    }
  };
  const t = content[language];
  const brands = [{
    name: 'Amazon',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg'
  }, {
    name: 'Shopify',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0e/Shopify_logo_2018.svg'
  }, {
    name: 'eBay',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1b/EBay_logo.svg'
  }, {
    name: 'Etsy',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/89/Etsy_logo.svg'
  }, {
    name: 'Walmart',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/ca/Walmart_logo.svg'
  }, {
    name: 'WooCommerce',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2a/WooCommerce_logo.svg'
  }];
  return <section className="w-full py-16 bg-gradient-to-b from-white to-gray-50" data-id="element-45">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-46">
        <div className="text-center mb-12" data-id="element-47">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-[#142B44]/10 rounded-full mb-4" data-id="element-48">
            <ShoppingBag className="text-[#142B44]" size={20} data-id="element-49" />
            <span className="text-sm font-semibold text-[#142B44] uppercase tracking-wide" data-id="element-50">
              E-Commerce
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#142B44] mb-3" data-id="element-51">
            {t.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-52">
            {t.subtitle}
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center" data-id="element-53">
          {brands.map(brand => <div key={brand.name} className="flex items-center justify-center p-6 bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 border border-gray-100" data-id="element-54">
              <img src={brand.logo} alt={brand.name} className="h-8 w-auto object-contain transition-all duration-300" data-id="element-55" />
            </div>)}
        </div>
      </div>
    </section>;
}